// Is not depend on environment
//
const GB_FUNDRAISING_COMPANIES_OLD_LIST = [
  {
    name: "Beatson Cancer Charity",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/beatson_cancer_charity.png",
    descriptionKey: "",

    beneficiaryAccountId: "1373523",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1373523",
  },
  {
    name: "Birmingham Hospice",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/birmingham_hospice.png",
    descriptionKey: "",

    beneficiaryAccountId: "1547155",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1547155",
  },
  {
    name: "Catherine McEwan Foundation",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/catherine_mcewan_foundation.png",
    descriptionKey: "",

    beneficiaryAccountId: "1505947",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1505947",
  },
  {
    name: "Children With Cancer UK",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/children_with_cancer_uk.png",
    descriptionKey: "",

    beneficiaryAccountId: "1373029",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1373029",
  },
  {
    name: "Encephalitis International",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/encephalitis_international.png",
    descriptionKey: "",

    beneficiaryAccountId: "1534223",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1534223",
  },
  {
    name: "INSPIRE",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/inspire.png",
    descriptionKey: "",

    beneficiaryAccountId: "1388523",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1388523",
  },
  {
    name: "Making the Leap",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/making_the_leap.png",
    descriptionKey: "",

    beneficiaryAccountId: "1373669",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1373669",
  },
  {
    name: "Mental Health Matters",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/mental_health_matters.png",
    descriptionKey: "",

    beneficiaryAccountId: "1374301",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1374301",
  },
  {
    name: "Rethink Mental Illness",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/rethink_mental_illness.png",
    descriptionKey: "",

    beneficiaryAccountId: "1372724",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1372724",
  },
  {
    name: "Spina Bifida Hydrocephalus Scotland",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/spina_bifida_hydrocephalus_scotland.png",
    descriptionKey: "",

    beneficiaryAccountId: "1546737",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1546737",
  },
  {
    name: "Teenage Cancer Trust",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/teenage_cancer_trust.png",
    descriptionKey: "",

    beneficiaryAccountId: "1374359",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1374359",
  },
  {
    name: "The Last Kiss Foundation",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/the_last_kiss_foundation.png",
    descriptionKey: "",

    beneficiaryAccountId: "1534460",
    eventCampaingId: "14142",
    waitForCompletion: true,
    gtmId: "1534460",
  },
  {
    name: "other",
    hasImage: false,
    logo: "",
    descriptionKey: "charity_select_other_later",

    beneficiaryAccountId: null,
    eventCampaingId: "14142",
    waitForCompletion: false,
    gtmId: "Choice",
  },
];
const GB_FUNDRAISING_COMPANIES = [
  {
    name: "Macmillan Cancer Support",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/checkout/givestar/macmillan.png",
    charityId: "ca2afb40-0864-4262-98d4-22428b987320",
    total: 350,
  },
  // {
  //   name: "Mind",
  //   hasImage: true,
  //   logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/checkout/givestar/mind.png",
  //   charityId: "731c9500-e11e-464b-8b33-d58fbaa01c95",
  // },
  {
    name: "Cancer Research UK",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/checkout/givestar/cruk.png",
    charityId: "360d62fc-f385-4a06-9073-e19bed1a50b4",
    total: 350,
  },
  {
    name: "Alzheimer's Research UK",
    hasImage: true,
    logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/checkout/givestar/aruk.png",
    charityId: "ac20d143-edf8-4f0e-a794-c779b7f26576",
    total: 350,
  },
];
const GB_FUNDRAISING_AMOUNT_LIST = [
  {
    total: 350,
    currency: "GBP",
    isPopular: true,
  },
  {
    total: 500,
    currency: "GBP",
    isPopular: false,
  },
  {
    total: 750,
    currency: "GBP",
    isPopular: false,
  },
];

const config = {
  local: {
    // us: {
    //   // Red Cross
    //   // https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/red_cross.png
    //   fundraisingCompanies: [
    //     {
    //       name: "American Cancer Society",
    //       hasImage: true,
    //       logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/cancer.png",
    //       descriptionKey: "",

    //       beneficiaryAccountId: "1370254",
    //       eventCampaingId: "13250",
    //       waitForCompletion: true,
    //       gtmId: "1370254",
    //     },
    //     {
    //       name: "other",
    //       hasImage: false,
    //       logo: "",
    //       descriptionKey: "charity_select_other_later",

    //       beneficiaryAccountId: null,
    //       eventCampaingId: "13365",
    //       waitForCompletion: false,
    //       gtmId: "Choice",
    //     },
    //   ],
    // },
    eu: {
      fundraisingCompanies: GB_FUNDRAISING_COMPANIES,
      // fundraisingAmountList: GB_FUNDRAISING_AMOUNT_LIST,
    },
    // Hidden link
    test: {
      fundraisingCompanies: GB_FUNDRAISING_COMPANIES_OLD_LIST,
      fundraisingAmountList: GB_FUNDRAISING_AMOUNT_LIST,
    },
  },
  staging: {
    // us: {
    //   fundraisingCompanies: [
    //     {
    //       name: "American Cancer Society",
    //       hasImage: true,
    //       logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/cancer.png",
    //       descriptionKey: "",

    //       beneficiaryAccountId: "1370254",
    //       eventCampaingId: "13250",
    //       waitForCompletion: true,
    //       gtmId: "1370254",
    //     },
    //     {
    //       name: "other",
    //       hasImage: false,
    //       logo: "",
    //       descriptionKey: "charity_select_other_later",

    //       beneficiaryAccountId: null,
    //       eventCampaingId: "13365",
    //       waitForCompletion: false,
    //       gtmId: "Choice",
    //     },
    //   ],
    // },
    eu: {
      fundraisingCompanies: GB_FUNDRAISING_COMPANIES,
      // fundraisingAmountList: GB_FUNDRAISING_AMOUNT_LIST,
    },
  },
  production: {
    // us: {
    //   fundraisingCompanies: [
    //     {
    //       name: "American Cancer Society",
    //       hasImage: true,
    //       logo: "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/affiliate_logos/cancer.png",
    //       descriptionKey: "",

    //       beneficiaryAccountId: "1370254",
    //       eventCampaingId: "13250",
    //       waitForCompletion: true,
    //       gtmId: "1370254",
    //     },
    //     {
    //       name: "other",
    //       hasImage: false,
    //       logo: "",
    //       descriptionKey: "charity_select_other_later",

    //       beneficiaryAccountId: null,
    //       eventCampaingId: "13365",
    //       waitForCompletion: false,
    //       gtmId: "Choice",
    //     },
    //   ],
    // },
    gb: {
      fundraisingCompanies: GB_FUNDRAISING_COMPANIES,
      // fundraisingAmountList: GB_FUNDRAISING_AMOUNT_LIST,
    },
  },
};

export const CHECKOUT_CONFIG = config[process.env.VUE_APP_ENV];
